import React, { useState } from 'react';
import YouTube from 'react-youtube';
import { FaPlayCircle } from 'react-icons/fa';
import './ProjectCard.css';

const ProjectCard = ({ project }) => {
  const [showVideo, setShowVideo] = useState(false);

  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 1,
      modestbranding: 1,
      rel: 0,
    },
  };

  return (
    <div className="project-card">
      <h3>{project.title}</h3>
      <p>{project.description}</p>
      <div className="player-wrapper">
        {showVideo ? (
          <YouTube videoId={project.videoId} opts={opts} className="youtube-actual-iframe" />
        ) : (
          <div className="thumbnail-container" onClick={() => setShowVideo(true)}>
            <img
              src={`https://img.youtube.com/vi/${project.videoId}/0.jpg`}
              alt={`Thumbnail for ${project.title} video`}
              className="youtube-thumbnail"
            />
            <FaPlayCircle className="play-icon" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
